export default "__VITE_ASSET__BlJqzE8U__"